import { Alert, Button } from '@mui/material';

import { CLIENT_BRAND_NAME } from '../branding';
import { useBrokerageCanvasserDirectory } from './BrokerageCanvasserDirectoryContext';

export const BrokerageCanvasserDirectoryFailureNotice = () => {
  const { status, retry } = useBrokerageCanvasserDirectory();

  if (status !== 'error') return null;

  return (
    <Alert
      severity="warning"
      sx={{ mx: 2, mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={retry} aria-label="Retry Core canvasser directory">
          Retry directory
        </Button>
      }
    >
      Couldn&apos;t load canvasser names from Core. {CLIENT_BRAND_NAME} data remains available.
    </Alert>
  );
};
